export default function isVisualTest(): boolean {
  return IS_STORYBOOK && new URLSearchParams(location.search).has('block-animations')
}
